import React from "react";
import FloatingWhats from "../Components/FloatingWhats.jsx";
import Header from "../Components/Header.jsx";
import { Grid2 } from "@mui/material";
import Card from "../Components/Card.jsx";
import BottomBar from "../Components/BottomBar.jsx";
import Footer from "../Components/Footer.jsx";

const PesagemRodoviaria = () => {


    return (
        <div className="container">
            <FloatingWhats/>
            <Header/>
            <div className="content">
                <div className="bannerInterno-container">
                    <div className="bannerInterno-content from-top">
                        <div className="bannerInterno">
                            <h1 className="bannerInterno-title">Pesagem<br/>Rodoviária</h1>
                            <img className="bannerInterno-img" src="../images/bc-mm1.png" alt="Banner Produtos"/>
                        </div>
                    </div>
                </div>
                <div className="caminho">
                    <div className="caminho-content from-left">
                        <a className="caminho-link" href="/">Início</a>
                        <span className="caminho-separador">/</span>
                        <a className="caminho-link" href="/produtos">Produtos</a>
                        <span className="caminho-separador">/</span>
                        <span className="caminho-atual">Pesagem Rodoviária</span>
                    </div>
                </div>
                <div className="listaTitle">
                    <h2 className="lista-produto-title from-left" style={{transitionDelay:'0.1s'}}>Balanças</h2>
                </div>
                <div className="produtos from-bottom">
                    <div className="lista-produtos" style={{marginBottom: '40px'}}>
                        <Grid2 className='produtos-grid' columns={{ xs:4, sm:8, md:12}} container spacing={5}>
                            <Grid2 item>
                                <Card link='/produtos/pesagem-rodoviaria/balanca-concreto-cc' cardImg={`../images/cc.png`} title={<>(CC)<br/>Concreto</>}/>
                            </Grid2>
                            <Grid2 item>
                                <Card link='/produtos/pesagem-rodoviaria/balanca-concreto-sd' cardImg={`../images/sd.png`} title={<>(SD)<br/>Concreto</>}/>
                            </Grid2>
                            <Grid2 item>
                                <Card link='/produtos/pesagem-rodoviaria/balanca-mista-modular-mm' cardImg={`../images/mm.png`} title={<>(MM)<br/>Mista Modular</>}/>
                            </Grid2>
                            <Grid2 item>
                                <Card link='/produtos/pesagem-rodoviaria/balanca-total-metalica-modular-tmm' cardImg={`../images/tmm.png`} title={<>(TMM)<br/>Total Metálica Modular</>}/>
                            </Grid2>
                            
                        </Grid2>
                    </div>
                </div>
                <div className="listaTitle">
                    <h2 className="lista-produto-title from-left">Células de Carga</h2>
                </div>
                <div className="produtos from-bottom">
                    <div className="lista-produtos" style={{marginBottom: '40px'}}>
                        <Grid2 className='produtos-grid' columns={{ xs:4, sm:8, md:12}} container spacing={5}>
                            <Grid2 item>
                                <Card link='/produtos/pesagem-rodoviaria/celula-pdx' cardImg={`../images/celula-pdx.png`} title={<>Mettler Toledo<br/>PDX - Digital</>}/>
                            </Grid2>
                            <Grid2 item>
                                <Card link='/produtos/pesagem-rodoviaria/celula-brc3a' cardImg={`../images/celula-brc3a.png`} title={<>Weightech<br/>BRC3 - Analógica</>}/>
                            </Grid2>
                            <Grid2 item>
                                <Card link='/produtos/pesagem-rodoviaria/celula-brc3d' cardImg={`../images/celula-brc3d.png`} title={<>Weightech<br/>BRC3 D - Digital</>}/>
                            </Grid2>
                            <Grid2 item>
                                <Card link='/produtos/pesagem-rodoviaria/celula-bsds' cardImg={`../images/celula-bsds.png`} title={<>Weightech<br/>BSDS - Digital</>}/>
                            </Grid2>
                        </Grid2>
                    </div>
                </div>
                {/* <div className="listaTitle">
                    <h2 className="lista-produto-title from-left">Softwares</h2>
                </div>
                <div className="produtos from-bottom">
                    <div className="lista-produtos" style={{marginBottom: '40px'}}>
                        <Grid2 className='produtos-grid' columns={{ xs:4, sm:8, md:12}} container spacing={5}>
                            <Grid2 item>
                                <Card link='/produtos/pesagem-rodoviaria/bc-net' cardImg={`../images/cad.png`} title='BC-Net'/>
                            </Grid2>
                            <Grid2 item>
                                <Card link='/produtos/pesagem-rodoviaria/bc-rodo' cardImg={`../images/bc-rodo.png`} title='BC-Rodo'/>
                            </Grid2>
                        </Grid2>
                    </div>
                </div>
                <div className="listaTitle">
                    <h2 className="lista-produto-title from-left">Diversos</h2>
                </div>
                <div className="produtos from-bottom">
                    <div className="lista-produtos" style={{marginBottom: '40px'}}>
                        <Grid2 className='produtos-grid' columns={{ xs:4, sm:8, md:12}} container spacing={5}>
                            <Grid2 item>
                                <Card link='/produtos/pesagem-rodoviaria/conversor-analogico-digital' cardImg={`../images/cad.png`} title={<>(CAD)<br/>Conversor Analógico Digital</>}/>
                            </Grid2>
                        </Grid2>
                    </div>
                </div> */}
















                <BottomBar/>
                <Footer/>
            </div>
        </div>
    )
}
export default PesagemRodoviaria;